export default "f3632a74ff298d36.svg"